import { FC, useLayoutEffect, useRef } from "react";
import { dayWidth, weekWidth, zoom2ColumnWidth } from "../../constants";
import Icon from "../Icon";
import {
  StyledContentWrapper,
  StyledInnerWrapper,
  StyledText,
  StyledTextWrapper,
  StyledTooltipBeak,
  StyledTooltipContent,
  StyledTooltipWrapper,
} from "./styles";
import { TooltipProps } from "./types";

const Tooltip: FC<TooltipProps> = ({ tooltipData, zoom }) => {
  const { coords, disposition } = tooltipData;

  const tooltipRef = useRef<HTMLDivElement>(null);
  let width = weekWidth;
  switch (zoom) {
    case 0:
      width = weekWidth;
      break;
    case 1:
      width = dayWidth;
      break;
    case 2:
      width = zoom2ColumnWidth;
      break;
  }

  useLayoutEffect(() => {
    // re calculate tooltip width before repaint
    if (!tooltipRef.current) return;

    const { width: tooltipWidth } = tooltipRef.current.getBoundingClientRect();

    let xOffset;
    switch (zoom) {
      case 2:
        xOffset = tooltipWidth / 2 + width;
        break;
      default:
        xOffset = tooltipWidth / 2 + width / 2;
        break;
    }
    tooltipRef.current.style.left = `${coords.x - xOffset}px`;
    tooltipRef.current.style.top = `${coords.y + 8}px`;

    // disposition.overtime affects tooltip's width, thus it's needed to recalculate it's coords whenever overtime changes
  }, [coords.x, width, disposition.overtime, coords.y, zoom]);

  return (
    <StyledTooltipWrapper ref={tooltipRef}>
      <StyledTooltipContent>
        <StyledContentWrapper>
          <StyledInnerWrapper>
            <Icon iconName="calendarFree" height="14" fill="#aaff1e" />
            <StyledTextWrapper>
              <StyledText>{`Alocação: ${disposition.allocation.hours}h`}</StyledText>
            </StyledTextWrapper>
          </StyledInnerWrapper>

          <StyledInnerWrapper>
            <Icon iconName="calendarFree" height="14" fill="#781AA0" />
            <StyledTextWrapper>
              <StyledText>{`Alocação em grupo: ${disposition.allocationGroup.hours}h`}</StyledText>
            </StyledTextWrapper>
          </StyledInnerWrapper>

          <StyledInnerWrapper>
            <Icon iconName="calendarFree" height="14" fill="#ff1e1e" />
            <StyledTextWrapper>
              <StyledText>{`Indisponibilidade: ${disposition.unavailability.hours}h`}</StyledText>
            </StyledTextWrapper>
          </StyledInnerWrapper>

          <StyledInnerWrapper>
            <Icon iconName="calendarFree" height="14" fill="#008afd" />
            <StyledTextWrapper>
              <StyledText>{`Projeção: ${disposition.projection.hours}h`}</StyledText>
            </StyledTextWrapper>
          </StyledInnerWrapper>
        </StyledContentWrapper>
      </StyledTooltipContent>
      <StyledTooltipBeak />
    </StyledTooltipWrapper>
  );
};

export default Tooltip;
